/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The Tablet model module.
 * @module model/Tablet
 * @version 1.0.0
 */
export default class Tablet {
  /**
   * Constructs a new <code>Tablet</code>.
   * @alias module:model/Tablet
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>Tablet</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Tablet} obj Optional instance to populate.
   * @return {module:model/Tablet} The populated <code>Tablet</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Tablet()

      if (data.hasOwnProperty('uuid')) {
        obj['uuid'] = ApiClient.convertToType(data['uuid'], 'String')
      }
      if (data.hasOwnProperty('access_token')) {
        obj['access_token'] = ApiClient.convertToType(data['access_token'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {String} uuid
   */
  uuid = undefined
  /**
   * @member {String} access_token
   */
  access_token = undefined
}
